import { PersonAddress } from "source/shared/types"

export function isAddressComplete(address?: PersonAddress): boolean {
  return !!address && Object.values(address).every((value) => !!value.trim())
}
